var map = {
	"./Clothing.jpg": 8880,
	"./Electronics.jpg": 2135,
	"./Electronics.png": 711,
	"./Furniture.jpg": 5048,
	"./Guitar.jpg": 810,
	"./L.jpg": 9478,
	"./NoListingALt.png": 3112,
	"./Others.jpg": 5381,
	"./SLIDER.jpg": 9047,
	"./Schoolsports.jpg": 6441,
	"./Schoolsuplies.jpg": 619,
	"./ShivamDixit.jpg": 800,
	"./Shivamdixit.jpeg": 9017,
	"./Simran..jpg": 3876,
	"./Studmart_realistic_marketplace.jpg": 7899,
	"./Sunnyleone.jpg": 184,
	"./books.jpg": 7532,
	"./codecracker.webp": 2298,
	"./kiluakibehan.jpg": 2174,
	"./logoLakshyaveer.jpg": 3536,
	"./logoStudmart.webp": 9857,
	"./mitsuha.jpg": 8077,
	"./nightRaid.jpg": 24,
	"./nishachar.jpg": 13,
	"./productNewBie/Backpack.webp": 300,
	"./productNewBie/Bike.png": 4789,
	"./productNewBie/Drafter.png": 6612,
	"./productNewBie/Furniture.png": 594,
	"./productNewBie/Headphones.png": 7087,
	"./productNewBie/Laptop.webp": 2878,
	"./productNewBie/Mobile.webp": 7492,
	"./productNewBie/Myresume.pdf": 5909,
	"./productNewBie/Powerbank.png": 6001,
	"./productNewBie/Quantum.jpg": 3911,
	"./productNewBie/RAM&SSD.webp": 990,
	"./studmart.webp": 6542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8206;